/**
 * Appends `?subawardee=` (or `&subawardee=`) when a subawardee is selected so admin routes stay in sync.
 */
export function withAdminSubawardeeQuery(path: string, subawardee: string | null): string {
  if (!subawardee) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}subawardee=${encodeURIComponent(subawardee)}`;
}

/** List routes that show the shared "Filter by Subawardee" control */
export function isAdminSubawardeeFilterListRoute(pathname: string): boolean {
  const p = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;
  return p === '/admin/reports' || p === '/admin/milestones';
}
